const AuthPopupCallbackPage = () => null;

export default AuthPopupCallbackPage;
